import { jsx as _jsx } from "react/jsx-runtime";
export const BreadcrumbSeparator = () => {
    return (_jsx("svg", { fill: "currentColor", viewBox: "0 0 20 20", "aria-hidden": "true", children: _jsx("path", { d: "M5.555 17.776l8-16 .894.448-8 16-.894-.448z" }) }));
};
